'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Column = exports.Container = exports.Row = undefined;
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _themes = require('@marmalade/themes');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var containerWidths = Object.keys(_themes.breakpoints).reduce(function (acc, curr) {
  return Object.assign({}, acc, _defineProperty({}, (0, _themes.atLeast)(_themes.breakpoints[curr]), {
    width: _themes.breakpoints[curr]
  }));
}, {});
var containerStyles = function containerStyles(_ref) {
  var theme = _ref.theme;
  return Object.assign({
    position: 'relative',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: theme.space_sm,
    paddingRight: theme.space_sm
  }, _themes.clear, containerWidths);
};
var Container = (0, _glamorous2.default)('div')(containerStyles);
var rowStyles = function rowStyles(_ref2) {
  var theme = _ref2.theme;
  return Object.assign({
    marginLeft: '-' + theme.space_sm,
    marginRight: '-' + theme.space_sm
  }, _themes.clear);
};
var Row = (0, _glamorous2.default)('div')(rowStyles);
var columnStyles = function columnStyles(_ref3) {
  var theme = _ref3.theme,
    _ref3$offset = _ref3.offset,
    offset = _ref3$offset === undefined ? 0 : _ref3$offset,
    _ref3$size = _ref3.size,
    size = _ref3$size === undefined ? 1 : _ref3$size;
  return {
    display: 'block',
    float: 'left',
    marginLeft: offset * 100 + '%',
    minHeight: '1px',
    paddingLeft: theme.space_sm,
    paddingRight: theme.space_sm,
    position: 'relative',
    width: size * 100 + '%'
  };
};
var Column = (0, _glamorous2.default)('div')(columnStyles);
exports.Row = Row;
exports.Container = Container;
exports.Column = Column;